// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"72f8b5b3","513":"cceeaa71","787":"b5856225"}[chunkId] + ".chunk.js";
};